<ras-page [show_heading]="true" *ngIf="location" [headingHtml]="'<h1><b>' + location.name + '</b> storage units</h1>'" [mapUrl]="location.map_url" description="Household items, furniture, excess stock, bulk purchases, office records, trailers, vehicles, boats, sporting equipment&hellip; you can store it all. Our {{location.name}} storage units come in various sizes, so that you only pay for the extra space you need.">

	<main>
		<div class="breadcrumbs">
			<a [routerLink]="['/']">Home</a>
			&gt;
			<a [routerLink]="['/storage-facility', location.key]">{{location.name}} storage facility</a>
			&gt;
			Storage units
		</div>

		<ras-reservation *ngIf="location" (view_3d)="view_unit_in_3d($event)" [location]="location" [default]="unit_id" [size]="unit_size" [location_lookup]="location_lookup" [change]="change" (changed)="change = 0"></ras-reservation>

		<hr>

		<p>At Rent-A-Store, we understand that self-storage requirements differ from customer to customer. At our {{location.name}} storage facility, we offer a large variety of various storage spaces that allow you to choose the storage unit that will best suit your storage needs.</p>

		<p>Whether you are only needing to store a few items or an entire household, we have storage units that range from big to small so that you are able to use the perfect storage space for you. This means that there is no wastage of space or money. Our customers only pay for the storage space that they require, making self-storage a whole lot easier and affordable.</p>

	</main>

	<ras-testimonial></ras-testimonial>
	<ras-unit-interactive-view *ngIf="viewing_unit_3d != null" (close)="viewing_unit_3d = null" [unit]="viewing_unit_3d" [next]="next_unit_3d" [prev]="prev_unit_3d" (next_unit)="change = $event"></ras-unit-interactive-view>

</ras-page>
